export default {
  // 搜索
  searchPlaceholder: "搜索地址/哈希/调证用户ID",
  dataDetails: "数据详情",

  // 页面标题
  userDetails: "用户详情",

  // 按钮
  surveyReport: "调证报告",
  joinCanvas: "加入画布",
  downloadSurveyFile: "下载调证文件",

  // 加载
  loading: "拼命加载中",

  // 消息提示
  noAddressFound: "没有查出该地址",
};
